import articleTypes from "../../articles/constants/articleTypes";
import cloudRevenueStatuses from "../../works/constants/cloudRevenueStatuses";

import priceTypes from "./priceTypes";
import priceUnits from "./priceUnits";

// Audiobooks and podcasts share one, so a work pays at most one audio and one ebook start fee.
export const cloudStartFeePriceTypes = {
	[articleTypes.AUDIOBOOK]: priceTypes.CLOUD_START_FEE_AUDIO,
	[articleTypes.PODCAST]: priceTypes.CLOUD_START_FEE_AUDIO,
	[articleTypes.EBOOK]: priceTypes.CLOUD_START_FEE_EBOOK,
};

export const cloudRevenuePriceTypes = {
	[cloudRevenueStatuses.LIVE]: priceTypes.CLOUD_REVENUE_LIVE,
	[cloudRevenueStatuses.INACTIVE]: priceTypes.CLOUD_REVENUE_INACTIVE,
};

// Start fees are one-off; recurring revenues are per work and year.
export const cloudPriceUnits = {
	[priceTypes.CLOUD_START_FEE_AUDIO]: priceUnits.FIXED,
	[priceTypes.CLOUD_START_FEE_EBOOK]: priceUnits.FIXED,
	[priceTypes.CLOUD_REVENUE_LIVE]: priceUnits.YEAR,
	[priceTypes.CLOUD_REVENUE_INACTIVE]: priceUnits.YEAR,
};
